<template>
  <v-card color="primary" :title="`Hola ${userName}, aquí tienes una actualización sobre tu actividad`" text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua">
  </v-card>
</template>


<script>
import { useAuthStore } from '@/store/auth';

export default {
  computed: {
    userName() {
      const authStore = useAuthStore();
      return authStore.user?.name || 'Usuario'; 
    },
  },
};
</script>


<style>

</style>